export default {
    init() {
        // JavaScript to be fired on single person templates
        const $posts = $('.list-item-post');
        $('.btn--load-more').on('click', function () {
            $posts.removeClass('list-item-post--hidden');
            $(this).hide();
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-person.js